/**
 * Remove existing spell check suggestions popup
 * @param {boolean} force - Force removal regardless of timing
 */
export function removeSpellCheckPopup(force = false) {
  // Don't remove if popup was just created (within 200ms)
  if (
    !force &&
    window._spellCheckPopupTimestamp &&
    Date.now() - window._spellCheckPopupTimestamp < 200
  ) {
    return;
  }

  const existingPopup = document.getElementById('spellcheck-suggestions-popup');
  if (existingPopup) {
    existingPopup.remove();
    window._spellCheckPopupTimestamp = null;
    window._spellCheckPopupTextbox = null;
  }
}
